import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { agendaSlice } from "store/slices/agenda";
import { AgendaDueRow, computeNewlyCompleted } from "./marketing-plan-agenda";

interface AgendaSnoozeRow {
    contactId: string;
    touchpointId: string | null;
}

export const useAgendaInvalidation = () => {
    const trpcClient = trpc.useTRPC();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    return useCallback(async () => {
        const dueKey = trpcClient.marketingPlaybook.dueTouchpoints.queryKey();
        const snoozeKey = trpcClient.marketingPlaybook.activeSnoozes.queryKey();
        const readDue = (): AgendaDueRow[] => {
            const query = queryClient
                .getQueryCache()
                .findAll({ queryKey: dueKey, type: "active" })[0];
            return (query?.state.data as AgendaDueRow[] | undefined) ?? [];
        };
        const before = readDue();
        await Promise.all([
            queryClient.invalidateQueries({ queryKey: dueKey }),
            queryClient.invalidateQueries({ queryKey: snoozeKey }),
        ]);
        queryClient.invalidateQueries({
            queryKey: trpcClient.calendarEvents.listForCalendar.queryKey(),
        });
        const after = readDue();
        const snoozeQuery = queryClient
            .getQueryCache()
            .findAll({ queryKey: snoozeKey, type: "active" })[0];
        const snoozes = (snoozeQuery?.state.data as AgendaSnoozeRow[] | undefined) ?? [];
        const completed = computeNewlyCompleted(
            before,
            after,
            snoozes.map(snooze => ({
                contactId: snooze.contactId,
                touchpointId: snooze.touchpointId,
            })),
        );
        console.log("[my-agenda completion]", {
            before: before.map(row => row.touchpointId),
            after: after.map(row => row.touchpointId),
            snoozes: snoozes.length,
            completed: completed.map(item => item.touchpointId),
        });
        if (completed.length > 0) {
            dispatch(agendaSlice.actions.reportRecentlyCompleted(completed));
        }
    }, [trpcClient, queryClient, dispatch]);
};
